/**
 * Token-AND substring rank shared by the search palettes: -1 means no match,
 * higher means a better match (3 prefix, 2 word-prefix, 1 contains).
 */
export function searchRank(value: string, query: string): number {
  const title = value.toLowerCase();
  const tokens = query.toLowerCase().split(/\s+/).filter(Boolean);
  if (!tokens.every((token) => title.includes(token))) return -1;
  const first = tokens[0] ?? '';
  if (title.startsWith(first)) return 3;
  if (title.split(/[\s._-]+/).some((word) => word.startsWith(first))) return 2;
  return 1;
}
